import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getVibrationEquipment } from '@/service/vibrationEquipment';
import { useStore } from '@/store';
export default function useGuliaoList() {
  var store = useStore();
  var list2 = ref([]);
  var showLoading = ref(false);
  var type = ref('');
  var curSiderbarId = computed(function () {
    var _store$state$vibratio;
    return (_store$state$vibratio = store.state.vibrationEquipment.curSiderbarId) !== null && _store$state$vibratio !== void 0 ? _store$state$vibratio : 0;
  });
  // 获取主机汇总数据
  var getFacAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            list2.value = [];
            showLoading.value = true;
            _context.next = 5;
            return getVibrationEquipment(curSiderbarId.value);
          case 5:
            data = _context.sent;
            list2.value = _toConsumableArray(data.list);
            store.commit('vibrationEquipment/updateDeviceGroup', data.list);
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
          case 13:
            _context.prev = 13;
            showLoading.value = false;
            return _context.finish(13);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10, 13, 16]]);
    }));
    return function getFacAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  // 监听左侧菜单发生改变，左侧菜单切换时，groupID会发生改变，需要去请求对应菜单的数据
  watch(curSiderbarId, function () {
    console.log('grounpId发生了改变', curSiderbarId);
    getFacAsync();
  });
  return [list2, type, showLoading, getFacAsync];
}